import React from 'react';

import { Field, Form } from 'react-final-form';
import { useHistory, useParams } from 'react-router';

import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import AuthTitle from 'components/shared/Typography/AuthTitle';
import { GENERAL_ERROR_MESSAGE } from 'constants/texts';
import { useSnackbar } from 'hooks/useSnackbar';
import useValidationSchema from 'hooks/useValidationSchema';
import { axiosAuth } from 'utils/axios';
import logger from 'utils/logger';

import { GP_AUTH_SIGNIN_ROUTE, GP_AUTH_SIGNUP_ROUTE } from '../../Routes/constants';
import { useGuestPortalRouteBuilder } from '../../Routes/functions';
import { validationSchema } from './validationSchema';

const STATUSES = {
  CREATED: 'created',
  INVITED: 'invited',
  NOT_FOUND: 'not_found',
};

function Verify() {
  const { guestPortalId } = useParams();
  const history = useHistory();
  const onSnackbar = useSnackbar();
  const validate = useValidationSchema(validationSchema);
  const { buildRoute } = useGuestPortalRouteBuilder();

  const handleSubmit = async ({ email } = {}) => {
    try {
      const response = await axiosAuth.get(`guest_portals/${guestPortalId}/verify_email`, { params: { email } });

      if (response.data.status === STATUSES.CREATED) {
        history.push(buildRoute(GP_AUTH_SIGNIN_ROUTE, { email }));
      } else if (response.data.status === STATUSES.INVITED) {
        history.push(buildRoute(GP_AUTH_SIGNUP_ROUTE, { email }));
      } else {
        return {
          email: 'The email address used here must match the one that was sent the Guest Portal invitation.',
        };
      }
    } catch (err) {
      logger.error(err);
      onSnackbar(GENERAL_ERROR_MESSAGE, true);
    }
  };

  return (
    <Form onSubmit={handleSubmit} validate={validate}>
      {({ handleSubmit, submitting, hasValidationErrors }) => {
        return (
          <form onSubmit={handleSubmit} autoComplete="off">
            <AuthTitle>Please verify your email</AuthTitle>
            <Field component={FormGroupAdapter} name="email" placeholder="Email" type="text" />

            <FormActions isRight>
              <Button htmlType="submit" disabled={submitting || hasValidationErrors}>
                Verify
              </Button>
            </FormActions>
          </form>
        );
      }}
    </Form>
  );
}

export default Verify;
